<template>
    <div>
        <TopBackground :titles="'种植案例展示'" :smalls="smalls"/>
        <!-- detail -->
        <div class="container-s">
            <div>
                <p class="topTitle"><span>诊所：{{caseLib.sysClinic.name}}</span> <br><br>  医生：{{ caseLib.doctorName }}</p>
                <div class="headline">患者信息</div>
                <ul class="ulList">
                    <li>患者姓名：{{caseLib.patientName}}  </li>
                    <li>年龄：{{caseLib.patientAge}}  </li>
                    <li>性别：{{caseLib.patientSex}}  </li>
                    <li>主观要求：{{caseLib.patientReq}}  </li>
                    <li>现病史：{{caseLib.historyPresentIllness}}</li>
                </ul>
                <div class="headline">专科检测详情</div>
                <ul class="ulList">
                    <li>治疗方案：{{caseLib.specPlan}} </li>
                    <li>风险评估：{{ caseLib.specRiskAss }} </li>
                </ul>
              <ul class="ulImg"  v-for="item in attr(0)"  :key="item.id">
                <li> <img :src="item.url" alt=""></li>
              </ul>                <div class="headline">手术过程</div>
                <ul class="ulImg"  v-for="item in attr(1)"  :key="item.id">
                    <li> <img :src="item.url" alt=""></li>
                </ul>
                <div class="headline">临时修复</div>
              <ul class="ulImg"  v-for="item in attr(2)"  :key="item.id">
                <li> <img :src="item.url" alt=""></li>
              </ul>
                <div class="headline">最终修复对比</div>
              <ul class="ulImg"  v-for="item in attr(3)"  :key="item.id">
                <li> <img :src="item.url" alt=""></li>
              </ul>
<!--              <div class="headline">最终修复对比</div>-->
<!--                <ul class="ulList">-->
<!--                    <li>张三丰病历CT.zip</li>-->
<!--                </ul>-->
            </div>
            <div class="bottomBtn">
                <el-button type="primary" round style="width:360px"  @click="down">下载病例</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/util/request'
const dayjs = require('dayjs')
export default {
    data() {
        return {
            caseLib: {sysClinic:{},attachments:[]} ,
            smalls: []
        }
    },
  mounted() {
  this.getCase()
  },
  methods:{
       getCase(){
         const  id = this.$route.query.id;
         console.log(id)
         api.get('/case/detail?id='+id).then(res=>{
           // this.$set('caseLib',res.data)
           this.caseLib = res.data
           if(this.caseLib.sysClinic===null){
             this.caseLib.sysClinic={}
           }
           if(this.caseLib.createTime){
             this.smalls.push(dayjs(this.caseLib.createTime).format('YYYY-MM-DD'))
           }
         })
       },
       attr(type){
         const  s = this.caseLib.attachments.filter(e=>e.type===type)
         return s
       },
       down(){
         const  attrs = this.attr(4);
         if(attrs&&attrs.length===1){
           window.open(attrs[0].url)
         }
       }

    },
}
</script>

<style lang="scss" scoped>
.headline{
    font-size: 18px;
    border-bottom: 1px solid #ccc;
    margin-top: 40px;
    padding-bottom: 15px;
    margin-bottom: 25px;
    font-weight: 600;
}
.topTitle{
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
    span{
        color: #81D8CF;
    }
}
.ulList{
    line-height: 36px;
}
.ulImg{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    >li{
        width: calc(33.3% - 20px);
        height: 240px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
.bottomBtn{
    text-align: center;
    padding: 60px 0 100px;
}
</style>
